import { render, staticRenderFns } from "./Overall_user.vue?vue&type=template&id=6f49d4f6&scoped=true&"
import script from "./Overall_user.vue?vue&type=script&lang=js&"
export * from "./Overall_user.vue?vue&type=script&lang=js&"
import style0 from "./Overall.css?vue&type=style&index=0&id=6f49d4f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49d4f6",
  null
  
)

export default component.exports